module.exports = __webpack_public_path__ + "static/gallery01-424d1998018a46d6e54325f1d2811996.jpg";